import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { InfoReportNotification } from 'src/app/shared/models/info-report-notification';

@Component({
  selector: 'ness-info-report-notification',
  templateUrl: './info-report-notification.component.html'
})
export class InfoReportNotificationComponent implements OnInit {
  @Input() notification: InfoReportNotification;
  @Output() sublinkClicked = new EventEmitter();

  _notificationType: string = '';
  _header: string = '';
  _message: string = '';
  _tabidx: number = 0;

  ngOnInit() {
    if (this.notification != null) {
      this._header = this.notification.header;
      this._message = this.notification.message;
      this._notificationType = this.notification.NotificationType;
      this._tabidx = this.notification.TabIndex;
    }
  }

  ngOnChanges(changes: SimpleChanges) {    
    if (this.notification !== null) {
      this._header = this.notification.header;
      this._message = this.notification.message;
      this._notificationType = this.notification.NotificationType;
      this._tabidx = this.notification.TabIndex;
    }
  }

  clickLink(tabIndex:number) {
    this.sublinkClicked.emit(tabIndex);
  }
}
